import { useContext } from "react"
import { InteractionStatus } from "@azure/msal-browser"
import { useMsal } from "@azure/msal-react"
import { Button, Container, Text, VStack } from "@chakra-ui/react"

import { H1 } from "components"

import { ClientContext } from "context/ClientContext"

import { getSignInAuthority, parseMsalConfig } from "utilities/msalConfig"

export const LoggedOutPage = () => {
  const { instance, inProgress } = useMsal()
  const { client } = useContext(ClientContext)

  const handleSignIn = async () => {
    if (!instance || !client) {
      return
    }

    if (inProgress !== InteractionStatus.None) {
      return
    }

    await instance.clearCache()

    const config = parseMsalConfig(client)
    const authority = getSignInAuthority(config.authority)

    await instance.loginRedirect({
      scopes: ["openid", "offline_access"],
      authority,
      redirectStartPage: window.location.origin,
      redirectUri: window.location.origin,
    })
  }

  return (
    <Container maxW="container.md" marginTop="15vh">
      <VStack spacing={4} align="center">
        <H1>You have been signed out</H1>
        <Text>
          Thanks for using our application! You have successfully logged out.
        </Text>
        <Button size="lg" marginTop={4} onClick={handleSignIn}>
          Sign In Again
        </Button>
      </VStack>
    </Container>
  )
}
